import { render } from "./CreateQuestionModal.vue?vue&type=template&id=8d28ef10"
import script from "./CreateQuestionModal.vue?vue&type=script&lang=js"
export * from "./CreateQuestionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__